import { applyKernel } from './convolution';

/**
 * 3x3 unsharp mask via convolution.
 * `amount` ranges from 0 (no sharpening) to 100 (full unsharp mask).
 * The kernel is interpolated between the identity matrix and the unsharp mask.
 */
export function sharpen(source: ImageData, amount: number): ImageData {
  const t = amount / 100;

  // Identity kernel (no change)
  // [0, 0, 0,  0, 1, 0,  0, 0, 0]
  // Unsharp mask kernel
  // [0, -1, 0,  -1, 5, -1,  0, -1, 0]
  // Interpolation: identity + t * (unsharp - identity)
  const kernel = [
    0,      -t,     0,
    -t,  1 + 4*t,  -t,
    0,      -t,     0,
  ];

  return applyKernel(source, kernel, 3);
}
